import { createApi } from "@reduxjs/toolkit/query/react"; // Ensure correct import
import { axiosBaseQuery, pyrotchBaseUrl } from "../axios/AxiosInstance";
import { Milestone } from "../../models/Milestone";

interface AssignUserParams {
  projectId: number;
  userIds: any;
}

interface milestoneUsers {
  id: number;
  email: string;
  name: string;
  profilePhoto: string;
  roleId: number;
  roleName: string;
}

interface ProjectMilestones {
  id: number;
  milestoneName: string;
  startDate: string;
  endDate: string;
  sequence: number;
  userName: string;
  milestoneKey: string;
  description: string;
  milestoneUsers: milestoneUsers[];
}

interface Project {
  id: number;
  name: string;
  deadlineDate: string;
  createdDate: string | null;
  completionDate: string | null;
  requestType: string;
  productType: string;
  priorityStatus: string;
  projectStatus: string;
  key: string;
  tentativeCost: any;
  deliverableCount?: number | null;
}

interface ProjectData {
  project: Project;
  projectMilestones: ProjectMilestones[];
}

export const AssignUserApi = createApi({
  reducerPath: "assignUserApi", // Consistent naming
  tagTypes: ["UserAssignment"],
  baseQuery: axiosBaseQuery({
    baseUrl: `${pyrotchBaseUrl}v1/`, // Use template literals
  }),
  endpoints: (build) => ({
    assignUser: build.mutation<void, AssignUserParams>({
      query: ({ projectId, userIds }) => ({
        url: `project/${projectId}/assign-user`,
        method: "POST",
        data: userIds,
      }),
      invalidatesTags: ["UserAssignment"],
    }),
    getUsers: build.query<ProjectData, number>({
      query: (projectId) => ({
        url: `project/${projectId}`,
        mathod: "GET",
      }),
      providesTags: ["UserAssignment"],
    }),
    deleteUser: build.mutation<void, AssignUserParams>({
      query: ({ projectId, userIds }) => ({
        url: `project/${projectId}/remove-user?userId=${userIds}`,
        method: "DELETE",
      }),
      invalidatesTags: ["UserAssignment"],
    }),
    addedMilestones: build.mutation<
      any,
      { projectId: number; milestones: Milestone }
    >({
      query: ({ projectId, milestones }) => {
        return {
          url: `project/${projectId}/assign-milestones`,
          method: "POST",
          data: milestones,
        };
      },
      invalidatesTags: ["UserAssignment"],
    }),
  }),
});

export const {
  useAssignUserMutation,
  useLazyGetUsersQuery,
  useDeleteUserMutation,
  useAddedMilestonesMutation,
} = AssignUserApi;
